import hosts from './hosts'

export default [
  {
    id: 'c44db111-b60d-436e-ab63-38c7c3402406',
    name: 'Developer Tea',
    slug: 'developer-tea',
    description:
      'A podcast for developers designed to fit inside your tea break',
    simplecastId: 'c44db111-b60d-436e-ab63-38c7c3402406',
    artworkUrl: '/static/img/shows/developertea.jpg',
    iTunesUrl: 'https://geo.itunes.apple.com/ca/podcast/feed/id955596067',
    overcastUrl: 'https://overcast.fm/itunes955596067',
    pocketCastsUrl: 'http://pca.st/itunes/955596067',
    rssFeedUrl: 'https://feeds.simplecast.com/dLRotFGk',
    googlePodcastsUrl:
      'https://play.google.com/music/m/Isv2vlzebfo5xid4zolzxpqber4?t=Developer_Tea',
    castroUrl: 'https://castro.fm/itunes/955596067',
    breakerUrl: 'https://www.breaker.audio/developer-tea',
    applePodcastId: '955596067',
    twitterUsername: 'developertea',
    hosts: [hosts.jcutrell],
    featuredEpisodes: [],
    colors: {
      text: '#E54324',
      button: '#E54324',
    },
  },

  {
    id: '56e415f0-1911-44b3-9b1c-99551f7146c3',
    name: 'Design Details',
    slug: 'design-details',
    description: 'A weekly conversation about design process and culture',
    simplecastId: '56e415f0-1911-44b3-9b1c-99551f7146c3',
    artworkUrl: '/static/img/shows/designdetails.jpg',
    iTunesUrl: 'https://geo.itunes.apple.com/ca/podcast/feed/id947191070',
    overcastUrl: 'https://overcast.fm/itunes947191070',
    pocketCastsUrl: 'http://pca.st/itunes/947191070',
    rssFeedUrl: 'https://feeds.simplecast.com/eew_vyNL',
    googlePodcastsUrl:
      'https://play.google.com/music/m/Iyvjpq3k44ux2azsmvlxe3cc5by?t=Design_Details',
    castroUrl: 'https://castro.fm/itunes/947191070',
    breakerUrl: 'https://www.breaker.audio/design-details',
    applePodcastId: '947191070',
    twitterUsername: 'designdetailsfm',
    hosts: [hosts.marshallbock, hosts.brian_lovin],
    featuredEpisodes: [161416, 113490, 74759, 48685],
    websiteUrl: 'https://designdetails.fm',
    colors: {
      text: '#3D7B79',
      button: '#499290',
    },
  },

  {
    id: 'bb345168-48b7-41de-893c-a5434ce3e1c8',
    name: 'Immutable',
    slug: 'immutable',
    description: 'A short, weekly show about design and development',
    simplecastId: 'bb345168-48b7-41de-893c-a5434ce3e1c8',
    artworkUrl: '/static/img/shows/immutable.jpg',
    iTunesUrl: 'https://geo.itunes.apple.com/ca/podcast/feed/id1035147995',
    overcastUrl: 'https://overcast.fm/itunes1035147995',
    pocketCastsUrl: 'http://pca.st/itunes/1035147995',
    rssFeedUrl: 'http://simplecast.fm/podcasts/1332/rss',
    googlePodcastsUrl:
      'https://play.google.com/music/m/Ibpdxh2uj5dd6gh5aoim6vscp5e?t=Immutable',
    castroUrl: 'https://castro.fm/itunes/1035147995',
    breakerUrl: 'https://www.breaker.audio/immutable',
    applePodcastId: '1035147995',
    twitterUsername: 'ImmutableFM',
    hosts: [hosts.soffes, hosts.superbryntendo],
    featuredEpisodes: [],
    colors: {
      text: '#C93634',
      button: '#F65956',
    },
  },

  {
    id: '6e0667be-2a21-4fb2-94a0-584091012a8c',
    name: 'Does Not Compute',
    slug: 'does-not-compute',
    description:
      'A weekly chat about the lives and workflows of modern web developers',
    simplecastId: '6e0667be-2a21-4fb2-94a0-584091012a8c',
    artworkUrl: '/static/img/shows/dnc.jpg',
    iTunesUrl: 'https://geo.itunes.apple.com/ca/podcast/feed/id1048731980',
    overcastUrl: 'https://overcast.fm/itunes1048731980',
    pocketCastsUrl: 'http://pca.st/itunes/1048731980',
    rssFeedUrl: 'http://simplecast.fm/podcasts/1386/rss',
    googlePodcastsUrl: 'https://spec.fm/podcasts/does-not-compute',
    castroUrl: 'https://castro.fm/itunes/1048731980',
    breakerUrl: 'https://www.breaker.audio/does-not-compute',
    applePodcastId: '1048731980',
    twitterUsername: 'dnccast',
    hosts: [hosts.seanwashbot, hosts.schrockwell],
    featuredEpisodes: [],
    colors: {
      text: '#474747',
      button: '#474747',
    },
  },

  {
    id: '61f26f87-7970-4eaf-9958-42cc1e69d49f',
    name: 'Vicarious',
    slug: 'vicarious',
    description: "Everyday escapism from a designers' point of view.",
    simplecastId: '61f26f87-7970-4eaf-9958-42cc1e69d49f',
    artworkUrl: '/static/img/shows/vicarious.jpg',
    iTunesUrl: 'https://geo.itunes.apple.com/ca/podcast/feed/id1055180013',
    overcastUrl: 'https://overcast.fm/itunes1055180013',
    pocketCastsUrl: 'http://pca.st/itunes/1055180013',
    rssFeedUrl: 'http://simplecast.fm/podcasts/1457/rss',
    googlePodcastsUrl: 'https://spec.fm/podcasts/vicarious',
    castroUrl: 'https://castro.fm/itunes/1055180013',
    breakerUrl: 'https://www.breaker.audio/vicarious',
    applePodcastId: '1055180013',
    twitterUsername: 'vicarious_fm',
    hosts: [
      hosts.superbryntendo,
      hosts.marshallbock,
      hosts.sortino,
      hosts.sarahberus,
    ],
    featuredEpisodes: [],
    colors: {
      text: '#0F6CEB',
      button: '#0F6CEB',
    },
  },

  {
    id: '20f35050-e836-44cd-8f7f-fd13e8cb2e44',
    name: 'Fragmented',
    slug: 'fragmented',
    description:
      'An Android developer podcast where we talk about building good software and becoming better Android developers',
    simplecastId: '20f35050-e836-44cd-8f7f-fd13e8cb2e44',
    artworkUrl: '/static/img/shows/fragmented.jpg',
    iTunesUrl: 'https://geo.itunes.apple.com/ca/podcast/feed/id968779958',
    overcastUrl: 'https://overcast.fm/itunes968779958',
    pocketCastsUrl: 'http://pca.st/itunes/968779958',
    rssFeedUrl: 'http://simplecast.com/podcasts/1684/rss',
    googlePodcastsUrl:
      'https://play.google.com/music/m/Ipvgdmgnkk44rvdvdyg22lql4sq?t=Fragmented_-_Android_Developer_Podcast',
    castroUrl: 'https://castro.fm/itunes/968779958',
    breakerUrl:
      'https://www.breaker.audio/fragmented-android-developer-podcast',
    applePodcastId: '968779958',
    twitterUsername: 'FragmentedCast',
    hosts: [hosts.donnfelker, hosts.kaushikgopal],
    featuredEpisodes: [],
    colors: {
      text: '#0070DA',
      button: '#0090FB',
    },
  },

  {
    id: '7a9416eb-2a75-4ef1-a5c8-57ad0a96a3c1',
    name: 'Runtime',
    slug: 'runtime',
    description:
      'Sam Soffes and Caleb Davenport talk about Swift, iOS, and other things they like',
    simplecastId: '7a9416eb-2a75-4ef1-a5c8-57ad0a96a3c1',
    artworkUrl: '/static/img/shows/runtime.jpg',
    iTunesUrl: 'https://geo.itunes.apple.com/ca/podcast/feed/id1122203945',
    overcastUrl: 'https://overcast.fm/itunes1122203945',
    pocketCastsUrl: 'http://pca.st/itunes/1122203945',
    rssFeedUrl: 'http://simplecast.com/podcasts/2070/rss',
    googlePodcastsUrl: '',
    castroUrl: 'https://castro.fm/itunes/1122203945',
    breakerUrl: 'https://www.breaker.audio/runtime',
    applePodcastId: '1122203945',
    twitterUsername: 'runtimefm',
    hosts: [hosts.soffes, hosts.calebd],
    featuredEpisodes: [],
    colors: {
      text: '#6D3BEC',
      button: '#6D3BEC',
    },
  },

  {
    id: 'a5609d32-3853-483e-a2c1-5ff63e45be74',
    name: 'Orthogonal',
    slug: 'orthogonal',
    description: 'A show about finance, freelance and being better at both',
    simplecastId: 'a5609d32-3853-483e-a2c1-5ff63e45be74',
    artworkUrl: '/static/img/shows/orthogonal.jpg',
    iTunesUrl: 'https://geo.itunes.apple.com/ca/podcast/feed/id1131320952',
    overcastUrl: 'https://overcast.fm/itunes1131320952',
    pocketCastsUrl: 'http://pca.st/itunes/1131320952',
    rssFeedUrl: 'http://simplecast.com/podcasts/2128/rss',
    googlePodcastsUrl: '',
    castroUrl: 'https://castro.fm/itunes/1131320952',
    breakerUrl: 'https://www.breaker.audio/orthogonal',
    applePodcastId: '1131320952',
    twitterUsername: 'getorthogonal',
    hosts: [hosts.cfoandrew, hosts.mrbrettkelly],
    featuredEpisodes: [],
    colors: {
      text: '#0B5351',
      button: '#0B5351',
    },
  },

  {
    id: 'c0a958c6-59dd-45ad-b246-1b7a1a9e51f6',
    name: 'Swift Unwrapped',
    slug: 'swift-unwrapped',
    description:
      'A 30-minute spin off of Swift Weekly Brief and other Swifty news.',
    simplecastId: 'c0a958c6-59dd-45ad-b246-1b7a1a9e51f6',
    artworkUrl: '/static/img/shows/swiftunwrapped.jpg',
    iTunesUrl: 'https://geo.itunes.apple.com/ca/podcast/feed/id1209817203',
    overcastUrl: 'https://overcast.fm/itunes1209817203',
    pocketCastsUrl: 'http://pca.st/itunes/1209817203',
    rssFeedUrl: 'https://simplecast.com/podcasts/2693/rss',
    googlePodcastsUrl: '',
    castroUrl: 'https://castro.fm/itunes/1209817203',
    breakerUrl: 'https://www.breaker.audio/swift-unwrapped',
    applePodcastId: '1209817203',
    twitterUsername: 'swift_unwrapped',
    hosts: [hosts.simjp, hosts.jesse_squires],
    featuredEpisodes: [],
    websiteUrl: 'https://swiftunwrapped.github.io',
    colors: {
      text: '#D65A00',
      button: '#FF6B00',
    },
  },

  {
    id: '2c4ced36-7bff-4378-a79f-185721737a71',
    name: 'Toolsday',
    slug: 'toolsday',
    description:
      'A show about the latest in tech tools, tips, and tricks on Tuesdays at 2',
    simplecastId: '2c4ced36-7bff-4378-a79f-185721737a71',
    artworkUrl: '/static/img/shows/toolsday.jpg',
    iTunesUrl: 'https://geo.itunes.apple.com/ca/podcast/feed/id1063765302',
    overcastUrl: 'https://overcast.fm/itunes1063765302',
    pocketCastsUrl: 'http://pca.st/itunes/1063765302',
    rssFeedUrl: 'https://rss.simplecast.com/podcasts/4211/rss',
    googlePodcastsUrl: '',
    castroUrl: 'https://castro.fm/itunes/1063765302',
    breakerUrl: 'https://www.breaker.audio/toolsday',
    applePodcastId: '1063765302',
    twitterUsername: 'toolsday',
    hosts: [hosts.una, hosts.chrisdhanaraj],
    featuredEpisodes: [],
    colors: {
      text: '#2167A4',
      button: '#3A87C9',
    },
  },

  {
    id: 'e8c261a2-fca8-4c9a-82eb-73351f2fbe2a',
    name: 'Framework',
    slug: 'framework',
    description:
      'Framework is a podcast about the process of researching, planning and building that goes into bringing a product to market.',
    artworkUrl: '/static/img/shows/framework.jpg',
    simplecastId: 'e8c261a2-fca8-4c9a-82eb-73351f2fbe2a',
    iTunesUrl:
      'https://itunes.apple.com/ca/podcast/framework/id1373741352?mt=2',
    overcastUrl: 'https://overcast.fm/itunes1373741352',
    pocketCastsUrl: 'http://pca.st/itunes/1373741352',
    castroUrl: 'https://castro.fm/itunes/1373741352',
    breakerUrl: '',
    googlePodcastsUrl: '',
    rssFeedUrl: 'https://rss.simplecast.com/podcasts/9926/rss',
    applePodcastId: '1373741352',
    twitterUsername: '',
    hosts: [hosts.tomcreighton, hosts.therobhayes],
    featuredEpisodes: [],
    colors: {
      text: '#FC2464',
      button: '#FC2464',
    },
  },

  {
    id: 'bdb43d4d-bd1d-4fbc-bd60-40f1e3299aa3',
    name: 'React Podcast',
    slug: 'reactpodcast',
    description: 'Conversations about React with your favorite developers.',
    artworkUrl: '/static/img/shows/reactpodcast.jpg',
    simplecastId: 'bdb43d4d-bd1d-4fbc-bd60-40f1e3299aa3',
    iTunesUrl:
      'https://itunes.apple.com/us/podcast/the-react-podcast/id1341969432',
    overcastUrl: 'https://overcast.fm/itunes1341969432',
    pocketCastsUrl: 'http://pca.st/itunes/1341969432',
    castroUrl: 'https://castro.fm/itunes/1341969432',
    breakerUrl: '',
    googlePodcastsUrl: '',
    rssFeedUrl: 'https://rss.simplecast.com/podcasts/6265/rss',
    applePodcastId: '1341969432',
    twitterUsername: 'reactpodcast',
    hosts: [hosts.chantastic],
    featuredEpisodes: [],
    colors: {
      text: '#FFE001',
      button: '#FFE001',
    },
  },
  {
    id: '99999',
    name: 'Layout',
    slug: 'layout',
    description:
      'Layout is a weekly podcast about design, technology, programming and everything else',
    artworkUrl: '/static/img/shows/layout.png',
    simplecastId: null,
    iTunesUrl: 'https://geo.itunes.apple.com/ca/podcast/feed/id1050276556',
    overcastUrl: 'https://overcast.fm/itunes1050276556',
    pocketCastsUrl: 'http://pca.st/itunes/1050276556',
    castroUrl: 'https://castro.fm/itunes/1050276556',
    breakerUrl: 'https://www.breaker.audio/layout',
    googlePodcastsUrl: '',
    rssFeedUrl: 'http://layout.fm/rss',
    applePodcastId: '1050276556',
    twitterUsername: 'layoutfm',
    websiteUrl: 'https://layout.fm',
    hosts: [hosts.rafahari, hosts.vernalkick],
    featuredEpisodes: [],
    colors: {
      text: '#399434',
      button: '#4AC644',
    },
  },
]
